// extracted by mini-css-extract-plugin
module.exports = {"pager":"pager_pager__MU9eJ","prev":"pager_prev__2CtN5","next":"pager_next__2cZ-5","backbtn":"pager_backbtn__6DJ4a"};